<script>
import BaseLineItems from './../Edit/LineItems.vue'
import LineItem from './LineItem.vue'
export default {
  extends: BaseLineItems,
  components: {
    LineItem
  },
  mounted() {
    this.$emitter.on('action.order.delete-line-item', this.actionDeleteLineItem)
  },
  unmounted() {
    this.$emitter.off('action.order.delete-line-item', this.actionDeleteLineItem)
  },
  computed: {
    lineItemActions() {
      return [
        {
          type: 'action',
          id: 'order.duplicate-line-item',
          label: 'Duplicate'
        },
        {
          type: 'action',
          id: 'order.delete-line-item',
          label: 'Delete'
        }
      ]
    }
  },
  methods: {
    actionDeleteLineItem(e) {
      if (e.item?.identify && parseInt(e.item?.index) >= 0) {
        let lineItems = Object.values(this.lineItems)
        lineItems.splice(e.item?.index, 1)
        this.$emit('update:modelValue', lineItems)
      }
      return false
    }
  }
}
</script>
